'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBzAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 17.3333H28V2.66667H0V17.3333Z",
          fill: "#094995"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 2.66667H28V0L0 8.88109e-06V2.66667Z",
          fill: "#D5182F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V17.3333H0V20Z",
          fill: "#D5182F"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 16C17.3137 16 20 13.3137 20 10C20 6.68629 17.3137 4 14 4C10.6863 4 8 6.68629 8 10C8 13.3137 10.6863 16 14 16Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 6.66667C13.8893 6.66667 13.78 6.67204 13.6724 6.68252C13.3059 6.71818 12.9799 6.45002 12.9442 6.08356C12.9086 5.7171 13.1767 5.39112 13.5432 5.35545C13.6937 5.34081 13.8461 5.33333 14 5.33333C14.1539 5.33333 14.3063 5.34081 14.4568 5.35545C14.8233 5.39112 15.0914 5.7171 15.0558 6.08356C15.0201 6.45002 14.6941 6.71818 14.3276 6.68252C14.22 6.67204 14.1107 6.66667 14 6.66667ZM11.9775 6.48462C12.2112 6.7691 12.1701 7.18921 11.8856 7.42294C11.7167 7.5617 11.5617 7.71673 11.4229 7.88561C11.1892 8.17009 10.7691 8.21123 10.4846 7.97749C10.2001 7.74375 10.159 7.32365 10.3927 7.03917C10.5866 6.8032 10.8032 6.58662 11.0392 6.39274C11.3237 6.159 11.7438 6.20014 11.9775 6.48462ZM16.0225 6.48462C16.2562 6.20014 16.6763 6.159 16.9608 6.39274C17.1968 6.58662 17.4134 6.8032 17.6073 7.03917C17.841 7.32365 17.7999 7.74375 17.5154 7.97749C17.2309 8.21123 16.8108 8.17009 16.5771 7.88561C16.4383 7.71673 16.2833 7.5617 16.1144 7.42294C15.8299 7.18921 15.7888 6.76911 16.0225 6.48462ZM10.0836 8.94425C10.45 8.97991 10.7182 9.3059 10.6825 9.67236C10.672 9.77997 10.6667 9.88926 10.6667 10C10.6667 10.1107 10.672 10.22 10.6825 10.3276C10.7182 10.6941 10.45 11.0201 10.0836 11.0558C9.7171 11.0914 9.39112 10.8233 9.35545 10.4568C9.34081 10.3063 9.33333 10.1539 9.33333 10C9.33333 9.84606 9.34081 9.69368 9.35545 9.5432C9.39112 9.17675 9.7171 8.90858 10.0836 8.94425ZM17.9164 8.94425C18.2829 8.90858 18.6089 9.17675 18.6445 9.54321C18.6592 9.69368 18.6667 9.84606 18.6667 10C18.6667 10.1539 18.6592 10.3063 18.6445 10.4568C18.6089 10.8233 18.2829 11.0914 17.9164 11.0558C17.55 11.0201 17.2818 10.6941 17.3175 10.3276C17.328 10.22 17.3333 10.1107 17.3333 10C17.3333 9.88926 17.328 9.77997 17.3175 9.67236C17.2818 9.3059 17.55 8.97991 17.9164 8.94425ZM10.4846 12.0225C10.7691 11.7888 11.1892 11.8299 11.4229 12.1144C11.5617 12.2833 11.7167 12.4383 11.8856 12.5771C12.1701 12.8108 12.2112 13.2309 11.9775 13.5154C11.7438 13.7999 11.3237 13.841 11.0392 13.6073C10.8032 13.4134 10.5866 13.1968 10.3927 12.9608C10.159 12.6763 10.2001 12.2562 10.4846 12.0225ZM17.5154 12.0225C17.7999 12.2562 17.841 12.6763 17.6073 12.9608C17.4134 13.1968 17.1968 13.4134 16.9608 13.6073C16.6763 13.841 16.2562 13.7999 16.0225 13.5154C15.7888 13.2309 15.8299 12.8108 16.1144 12.5771C16.2833 12.4383 16.4383 12.2833 16.5771 12.1144C16.8108 11.8299 17.2309 11.7888 17.5154 12.0225ZM12.9442 13.9164C12.9799 13.55 13.3059 13.2818 13.6724 13.3175C13.78 13.328 13.8893 13.3333 14 13.3333C14.1107 13.3333 14.22 13.328 14.3276 13.3175C14.6941 13.2818 15.0201 13.55 15.0558 13.9164C15.0914 14.2829 14.8233 14.6089 14.4568 14.6445C14.3063 14.6592 14.1539 14.6667 14 14.6667C13.8461 14.6667 13.6937 14.6592 13.5432 14.6445C13.1767 14.6089 12.9086 14.2829 12.9442 13.9164Z",
          fill: "#118014"
        }
      )
    ]
  }
);
const VpFlagBzAsset = forwardRef(FlagBzAsset);

export { VpFlagBzAsset as default };
